import React from 'react';

import { Button, Modal, Table } from 'semantic-ui-react';
import API from '../services/api';
import _ from 'lodash';
import { SubOrder, AddTP, AddTPV } from './index';

class PositionActions extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			symbol: props.symbol,
			position: props.position,
			showedSubOrder: false,
			showedAddTP: false,
			showedAddTPV: false,
			screen: props.screen || 'trade'
		};
	}

	componentDidUpdate (prevProps) {
		if (this && this.props.symbol !== prevProps.symbol) {
			this.setState({
				symbol: this.props.symbol,
				position: this.props.position
			});
		}
	}

	async closePosition () {
		const { symbol } = this.props;
		let value = prompt('В каком процентном объеме закрыть позицию?', 100);
		value = (value ? Number(String(value).replace(',', '.')) : null);

		if (!_.isNil(value) && value > 0 && value < 100) {
			await API.Position.close(symbol, value)
				.catch(err => {
					console.error(err);
				});
		} else if (!_.isNil(value) && value >= 100) {
			await API.Position.delete(symbol)
				.catch(err => {
					console.error(err);
				});
		}
	}

	async makeAveraging () {
		const {
			position,
			symbol
		} = this.props;
		let value = prompt('В каком процентном объеме от депозита усреднить позицию?', 0);
		value = (value ? Number(String(value).replace(',', '.')) : null);

		if (!_.isNil(value) && value > 0) {
			const order = {
				'side': position.side,
				'percent': Number(value),
				'leverageLevel': position.leverage,
				'skip': true
				// 'orderType': 'Market'
			};

			if (_.toUpper(position.side) === 'BUY') {
				await API.Order.buy(symbol, order)
					.catch(err => {
						console.error(err);
					});
			}

			if (_.toUpper(position.side) === 'SELL') {
				await API.Order.sell(symbol, order)
					.catch(err => {
						console.error(err);
					});
			}
		}
	}

	async setTP () {
		const {
			position,
			symbol
		} = this.props;
		let value = prompt('Какую цену Тэйк-профит выставить?', Number(position.takeProfit) || Number(position.avgPrice));
		value = (value ? Number(String(value).replace(',', '.')) : null);

		if (!_.isNil(value) && value >= 0) {
			const order = {
				'value': Number(value),
				'orderType': 'Market',
				'triggerBy': 'LastPrice'
			};

			await API.Position.setTP(symbol, order)
				.catch(err => {
					console.error(err);
				});
		}
	}

	async setSL () {
		const {
			position,
			symbol
		} = this.props;
		let value = prompt('Какую цену Stop Loss выставить?', Number(position.stopLoss) || Number(position.avgPrice));
		value = (value ? Number(String(value).replace(',', '.')) : null);

		if (!_.isNil(value) && value >= 0) {
			const order = {
				'value': Number(value),
				'orderType': 'Market',
				'triggerBy': 'LastPrice'
			};

			await API.Position.setSL(symbol, order)
				.catch(err => {
					console.error(err);
				});
		}
	}

	async setNoLoss () {
		const {
			position,
			symbol
		} = this.props;
		let value = Number(prompt('Какой цену выставить для Б/У Stop Loss?', /* Number(position.stopLoss) || */ Number(position.avgPrice)) || 0);
		value = (value ? Number(String(value).replace(',', '.')) : null);

		if (value) {
			const order = {
				'value': value,
				'orderType': 'Market',
				'triggerBy': 'LastPrice',
				inPercent: false
			};

			await API.Position.setNoLoss(symbol, order)
				.catch(err => {
					console.error(err);
				});
		}
	}

	async setNoLossInPercent () {
		const {
			position,
			symbol
		} = this.props;
		let value = prompt('Какой процент P&L выставить для Б/У Stop Loss?', 1);
		value = (value ? Number(String(value).replace(',', '.')) : null);

		if (!_.isNil(value) && value >= 0) {
			const order = {
				'value': value,
				'orderType': 'Market',
				'triggerBy': 'LastPrice'
			};

			await API.Position.setNoLoss(symbol, order)
				.catch(err => {
					console.error(err);
				});
		}
	}

	async closePTP () {
		const {
			symbol
		} = this.props;
		const result = window.confirm('Закрыть все частичные тейк-профит ордера?');

		if (result) {
			await API.Order.closePTP(symbol)
				.catch(err => {
					console.error(err);
				});
		}
	}

	async closeLimit () {
		const {
			symbol
		} = this.props;
		const result = window.confirm('Закрыть все лимитные ордера?');

		if (result) {
			await API.Order.closeLimit(symbol)
				.catch(err => {
					console.error(err);
				});
		}
	}

	openModal = (key) => () => {
		this.setState({
			[key]: true
		});
	};

	closeModal = (key) => () => {
		this.setState({
			[key]: false
		});
	};

	render () {
		const {
			symbol,
			showedSubOrder,
			showedAddTP,
			showedAddTPV,
		} = this.state;

		const {
			position,
			screen
		} = this.props;

		return (
			<Table basic="very" celled collapsing>
				<Table.Body>
					<Table.Row key={`position_actions_row_1`}>
						{screen === 'trade' ? <Table.Cell key={`position_order_cell_key`}>
							<Button compact icon={'add'} onClick={() => this.makeAveraging()} color={'green'}/>
						</Table.Cell> : <></>}
						<Table.Cell key={`position_close_cell_value`}>
							<Button compact icon={'close'} onClick={() => this.closePosition()} color={'red'}/>
						</Table.Cell>
					</Table.Row>
					{screen === 'trade' ? <Table.Row key={`position_actions_row_2`}>
						<Table.Cell key={`position_tp_cell_key`}>
							<Button compact icon={'add'} content={'ТП'} onClick={() => this.setTP()}/>
						</Table.Cell>
						<Table.Cell key={`position_sl_cell_value`}>
							<Button compact icon={'add'} content={'СЛ'} onClick={() => this.setSL()}/>
						</Table.Cell>
						<Table.Cell key={`position_nl_cell_value`}>
							<Button compact icon={'add'} content={'$ БУ'} onClick={() => this.setNoLoss()}/>
						</Table.Cell>
						<Table.Cell key={`position_nl_cell_percent`}>
							<Button compact icon={'add'} content={'% БУ'} onClick={() => this.setNoLossInPercent()}/>
						</Table.Cell>
					</Table.Row> : <></>}
					{screen === 'trade' ? <Table.Row key={`position_actions_row_3`}>
						<Table.Cell key={`position_limit_cell_value`}>
							<Modal
								centered
								open={showedSubOrder}
								size="small"
								onOpen={this.openModal('showedSubOrder')}
								trigger={<Button compact icon={'add'} content={'Лимитку'}/>}
							>
								<SubOrder position={position} symbol={symbol}
										  closeModal={this.closeModal('showedSubOrder')}/>
							</Modal>
						</Table.Cell>
						<Table.Cell key={`position_ptp_cell_value`}>
							<Modal
								centered
								open={showedAddTPV}
								size="small"
								onOpen={this.openModal('showedAddTPV')}
								trigger={<Button compact icon={'add'} content={'$ ТП 1,2,3'}/>}
							>
								<AddTPV position={position} symbol={symbol}
										closeModal={this.closeModal('showedAddTPV')}/>
							</Modal>
						</Table.Cell>
						<Table.Cell key={`position_ptp_cell_percent`}>
							<Modal
								centered
								open={showedAddTP}
								size="small"
								onOpen={this.openModal('showedAddTP')}
								trigger={<Button compact icon={'add'} content={'% ТП 1,2,3'}/>}
							>
								<AddTP position={position} symbol={symbol} closeModal={this.closeModal('showedAddTP')}/>
							</Modal>
						</Table.Cell>
					</Table.Row> : <></>}
					{screen === 'trade' || screen === 'users' ? <Table.Row key={`position_actions_row_4`}>
						<Table.Cell key={`position_close_limit_cell_value`}>
							<Button compact icon="trash" content={'Лимитки'} onClick={() => this.closeLimit()}
									color={'red'}/>
						</Table.Cell>
						<Table.Cell key={`position_close_ptp_cell_value`}>
							<Button compact icon="trash" content={'ТП 1,2,3'} onClick={() => this.closePTP()}
									color={'red'}/>
						</Table.Cell>
					</Table.Row> : <></>}
				</Table.Body>
			</Table>
		);
	}
};

export default PositionActions;
